// extracted by mini-css-extract-plugin
export var Footer = "k_r";
export var aniSpin = "k_d";
export var audio = "k_t";
export var gradient = "k_s";